// extracted by mini-css-extract-plugin
module.exports = {"container":"e_-u","title":"e_av","image":"e_bv","mobileView":"e_cv"};